import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-438d6c1c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  style: {"flex":"1"}
}
const _hoisted_2 = { class: "tw-flex name__service" }
const _hoisted_3 = {
  style: {"border-radius":"4px"},
  class: "tw-text-[11px] tw-text-[#387DFF] tw-font-medium tw-bg-[#E4F1FF] tw-px-[5px] tw-py-[3px] tw-border-[4px]"
}
const _hoisted_4 = { style: {"position":"relative","flex":"1"} }
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = {
  key: 0,
  class: "asterisk",
  style: {"position":"absolute","top":"-3px","color":"red"}
}
const _hoisted_7 = { class: "tw-text-[14px] tw-text-[#211F58] tw-font-semibold" }
const _hoisted_8 = { class: "tw-flex tw-gap-[20px] tw-items-center button__more" }
const _hoisted_9 = {
  key: 0,
  class: "tw-py-[3px] tw-bg-[#FEE5E2] tw-px-[5px] tw-w-max tw-rounded-[4px] tw-mr-[10px]"
}
const _hoisted_10 = { class: "tw-m-[0px] tw-text-[#F7553C] tw-text-[11px] tw-leading-[130%] tw-font-medium" }
const _hoisted_11 = {
  key: 1,
  class: "tw-flex tw-gap-[10px]"
}
const _hoisted_12 = { class: "tw-text-[12px]" }
const _hoisted_13 = { class: "tw-text-[12px]" }
const _hoisted_14 = { class: "tw-flex" }
const _hoisted_15 = {
  key: 1,
  style: {"color":"red"}
}

import { Ref, ref, watch, onMounted } from "vue";
import CustomDropDownItem from "../common/customDropDownItem.vue";
import ButtonShowMore from "../common/setting/buttonShowMore.vue";
import ArrowIcon from "../svgs/arrowIcon.vue";
import { getComponentUiText } from "@/utils/utilities";
import eventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import VRuntimeTemplate from "vue3-runtime-template";
import SynchronizaIcon from "../svgs/synchronizaIcon.vue";
import { idWizardPage as idPage } from "@/utils/constants";


export default /*#__PURE__*/_defineComponent({
  __name: 'wizardDetailWrapper',
  props: {
  title: { type: String, default: "", required: false },
  isBgText: { type: Boolean, default: false },
  showAccordion: { type: Boolean, default: false, required: false },
  isVerified: { type: Boolean, default: false, required: false },
  isVerifiedEmail: { type: Boolean, default: false, required: false },
  showQuestion: { type: Boolean, default: true, required: false },
  isShowTagVerified: { type: Boolean, default: false, required: false },
  nameInput: { type: String, default: "", required: false },
  data: { type: Object, default: () => {}, required: false },
  validation: { type: Object, required: false, default: null },
  showValidateNow: { type: Boolean, default: false, required: false },
  isFocus: { type: Boolean, default: false, required: false },
  isPast: { type: Boolean, default: false, required: false },
  isFacingWeb: { type: Boolean, default: false, required: false },
  isApiError: { type: Object, default: null, required: false },
  pageActive: { type: Number, default: 0, required: false },
},
  emits: [
  "update:accordion",
  "update:input:name",
  "update:save:change",
],
  setup(__props, { emit }) {

const props = __props;



const nameInputRef = ref(props.nameInput);
const show: Ref<boolean> = ref(props.showAccordion);
const isFocus: Ref<boolean> = ref(props.isFocus);
watch(
  () => props.showAccordion,
  () => {
    show.value = props.showAccordion;
  },
);
watch(
  () => props.isFocus,
  () => (isFocus.value = props.isFocus),
);
watch(nameInputRef, () => {
  emit("update:input:name", nameInputRef.value);
});
watch(
  () => props.validation,
  (newValue, oldValue) => {
    if (newValue?.$errors[0]) {
      show.value = true;
    }
  },
  { deep: true },
);

const onValidate = () => {
  props.validation?.$validate();
};
const updateShowAccordion = () => {
  show.value = !show.value;
  emit("update:accordion", show.value);
};

const emitActionModalDelete = () => {
  if (props.isBgText) {
    const data = {
      ...props.data,
      indexGroup: props.data.groupIndex,
      currentIndex: props.data.currentIndex,
    };

    eventEmitter.emit(EmitterEvents.OPEN_WIZARD_DELETE_MODAL, data);
  } else {
    eventEmitter.emit(EmitterEvents.OPEN_WIZARD_DELETE_MODAL, props.data);
  }
};

const isComplexValidate = () => {
  const errors = props.validation?.$errors;
  for (const error of errors) {
    if (error.$validator === "required") {
      return true;
    } else if (!isFocus.value) {
      return true;
    }
  }
  return false;
};
const onBlurs = () => {
  onValidate();
};

onMounted(() => {
  const input = document.querySelector(".enter__name") as HTMLInputElement;
  const asterisks = document.querySelectorAll(".asterisk");

  if (input && asterisks.length) {
    adjustAsteriskPosition();
  }

  // Function declarations
  function adjustAsteriskPosition() {
    const placeholderWidth = getTextWidth(
      getComponentUiText(
        "app-menu-submenu-home-setup-wizard-service-input-placeholder-title-1",
      ),
      getComputedStyle(input).font,
    );
    asterisks.forEach((asterisk) => {
      const ele = asterisk as HTMLElement;
      if (ele) {
        ele.style.left = `${placeholderWidth + 10}px`;
      }
    });
  }

  function getTextWidth(text, font) {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    if (context) {
      context.font = font;
    }
    if (context) {
      return context.measureText(text).width;
    }
    return 0;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_b_form_invalid_feedback = _resolveComponent("b-form-invalid-feedback")!

  return (!__props.data?.item.isArchived)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(`${
      __props.isApiError && (!__props.data.item.id || __props.isApiError.isDelete)
        ? 'tw-border-[red] tw-border-solid tw-border-[1px] tw-rounded-md'
        : ''
    }`)
      }, [
        _createElementVNode("div", {
          class: _normalizeClass([
        __props.isApiError && (!__props.data.item.id || __props.isApiError.isDelete)
          ? 'tw-border-none'
          : '',
        'header tw-cursor-pointer tw-pl-[25px] tw-pr-[15px] tw-py-[22px] tw-flex tw-justify-between',
        show.value && __props.showQuestion ? 'show' : '',
        __props.validation?.$errors[0] && isComplexValidate() ? 'is-invalid-box' : '',
        __props.isApiError && __props.data.item.id && (__props.isApiError.name || __props.isApiError.brandName)
          ? 'border-invalid'
          : '',
      ]),
          style: {"max-height":"60px"}
        }, [
          (__props.isBgText)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_3, _toDisplayString(props.title), 1)
                  ]),
                  _createElementVNode("div", _hoisted_4, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((nameInputRef).value = $event)),
                      class: _normalizeClass(`enter__name ${__props.validation.$error[0] ? 'is-invalid' : ''}`),
                      placeholder: 
                _unref(getComponentUiText)(
                  'app-menu-submenu-home-setup-wizard-service-input-placeholder-title-1',
                )
              ,
                      style: {"border":"unset","background-color":"unset"},
                      "data-cy": "wizard-detail-wrapper-input-name",
                      onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
                      onBlur: onBlurs
                    }, null, 42, _hoisted_5), [
                      [_vModelText, nameInputRef.value]
                    ]),
                    (!nameInputRef.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, "* "))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (!__props.isBgText)
            ? _renderSlot(_ctx.$slots, "title", { key: 1 }, () => [
                _createElementVNode("span", _hoisted_7, _toDisplayString(props.title), 1)
              ])
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_8, [
            (__props.isApiError && __props.data.item.id && !__props.isApiError.isDelete)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(getComponentUiText)("app-component-wizards-setup-error-update")), 1)
                ]))
              : _createCommentVNode("", true),
            (__props.isShowTagVerified)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("div", {
                    class: _normalizeClass(`${
              __props.isVerified ? 'activeStatus' : 'require'
            } cell-status-domain tw-flex tw-items-center`)
                  }, [
                    _createElementVNode("span", _hoisted_12, _toDisplayString(__props.isVerified
                ? _unref(getComponentUiText)(
                    "app-component-table-cell-status-dns-verified-1",
                  )
                : _unref(getComponentUiText)(
                    "app-component-table-cell-status-dns-not-verified-1",
                  )), 1)
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(`${
              __props.isVerifiedEmail ? 'activeStatus' : 'require'
            } cell-status-domain tw-flex tw-items-center`)
                  }, [
                    _createElementVNode("span", _hoisted_13, _toDisplayString(__props.isVerifiedEmail
                ? _unref(getComponentUiText)(
                    "app-component-table-cell-status-email-verified-1",
                  )
                : _unref(getComponentUiText)(
                    "app-component-table-cell-status-email-not-verified-1",
                  )), 1)
                  ], 2)
                ]))
              : _createCommentVNode("", true),
            (__props.isPast)
              ? (_openBlock(), _createBlock(SynchronizaIcon, {
                  key: 2,
                  class: "tw-mr-[10px]"
                }))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(ButtonShowMore, {
                classes: '!tw-py-0 !tw-px-0 !tw-border-0',
                "id-popover": 
              'popover-wizard-detail-wrapper-' +
              __props.pageActive +
              '-' +
              Math.random() * 1000
            
              }, {
                default: _withCtx(() => [
                  _createVNode(CustomDropDownItem, {
                    style: 'normal',
                    "id-text": 'app-settings-domain-verify-modal-delete-button-1',
                    "style-text": "!tw-border-none !tw-text-[#f7553c]",
                    onClick: emitActionModalDelete
                  })
                ]),
                _: 1
              }, 8, ["id-popover"]),
              _createElementVNode("div", {
                class: "tw-p-[10px] tw-flex tw-items-center tw-justify-start tw-ml-[10px]",
                onClick: updateShowAccordion
              }, [
                _createVNode(ArrowIcon, {
                  class: _normalizeClass(['right-arrow-icon', show.value ? 'show' : ''])
                }, null, 8, ["class"])
              ])
            ])
          ])
        ], 2),
        (__props.showAccordion)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(`tw-flex name__service error-box ${
        __props.validation?.$errors[0] ? 'tw-mt-[3px]' : ''
      }`)
            }, [
              _createVNode(_component_b_form_invalid_feedback, {
                class: _normalizeClass({ 'is-invalid': __props.validation?.$error })
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(VRuntimeTemplate), {
                    template: __props.validation?.$errors?.[0]?.$message
                  }, null, 8, ["template"])
                ]),
                _: 1
              }, 8, ["class"])
            ], 2))
          : _createCommentVNode("", true),
        (
        __props.validation?.$errors?.[0]?.$message &&
        __props.showValidateNow &&
        isComplexValidate()
      )
          ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
              _createVNode(_component_b_form_invalid_feedback, {
                class: _normalizeClass({ 'is-invalid': __props.validation?.$error })
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(VRuntimeTemplate), {
                    template: __props.validation?.$errors?.[0]?.$message
                  }, null, 8, ["template"])
                ]),
                _: 1
              }, 8, ["class"])
            ]))
          : _createCommentVNode("", true),
        (__props.showQuestion)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: _normalizeClass([
        'tw-mt-[3px]',
        'content-container',
        show.value ? 'show' : '',
        __props.isApiError && (!__props.data.item.id || __props.isApiError.isDelete)
          ? 'tw-border-none'
          : '',
      ])
            }, [
              _renderSlot(_ctx.$slots, "default")
            ], 2))
          : _createCommentVNode("", true)
      ], 2))
    : _createCommentVNode("", true)
}
}

})